import { ItemTypesMapIdType } from "@shared/constants/enums/enums-types";
import {
  parseFromLocalStorage,
  set as setCacheStorage,
  remove as removeCacheStorage,
} from "@shared/utils/storage/cache-storage";
import { addMinutesToDate } from "@shared/utils/dates/arithmetic";

export class PwycPriceManager {
  private static instance: PwycPriceManager;
  private readonly cacheKey = "pwyc-prices";

  // eslint-disable-next-line no-useless-constructor, @typescript-eslint/no-empty-function
  private constructor() {} // intentional in singleton pattern

  public static getInstance(): PwycPriceManager {
    if (!PwycPriceManager.instance) {
      PwycPriceManager.instance = new PwycPriceManager();
    }
    return PwycPriceManager.instance;
  }

  private getPricesFromStorage():
    | {
        [key in ItemTypesMapIdType]?: Record<number, string>;
      }
    | undefined {
    return parseFromLocalStorage<{
      $value: Record<ItemTypesMapIdType, Record<number, string>>;
    }>(this.cacheKey)?.$value;
  }

  public get pwycPrices():
    | {
        [key in ItemTypesMapIdType]?: Record<number, string>;
      }
    | undefined {
    return this.getPricesFromStorage();
  }

  public setPwycPrice(
    itemTypeId: number,
    price: string,
    itemType: ItemTypesMapIdType
  ): void {
    const currentPrices = this.getPricesFromStorage() || {};
    const currentTypePrices = currentPrices?.[itemType] || {};
    currentTypePrices[itemTypeId] = price;
    currentPrices[itemType] = currentTypePrices;
    setCacheStorage(
      this.cacheKey,
      currentPrices,
      addMinutesToDate(new Date(), 60)
    );
  }

  public getPwycPrice(
    itemTypeId: number,
    itemType: ItemTypesMapIdType
  ): string | undefined {
    const currentPrices = this.getPricesFromStorage();

    return currentPrices?.[itemType]?.[itemTypeId] || undefined;
  }

  public clearPwycPrices(): void {
    removeCacheStorage(this.cacheKey);
  }
}
